import {
  ObjectId,
  PopulatedWithParties,
  PopulatedWithStatements,
  QuestionSet,
  Stored,
} from "../types";
import ApiModule from "./base";

export type PopulatedQuestionSet = Stored<
  PopulatedWithStatements<PopulatedWithParties<QuestionSet>>
>;

export default class QuestionSetsModule extends ApiModule {
  constructor(baseURL: string) {
    super(baseURL, "question_sets");
  }

  async index(): Promise<Array<PopulatedQuestionSet>> {
    const request = new Request(this.url, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }

  async read(id: ObjectId): Promise<PopulatedQuestionSet> {
    const request = new Request(`${this.url}/${id}`, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }
}
